var _path, _mask, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 160,
    viewBox: "0 0 244 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H232C238.627 0 244 5.37258 244 12V112H0V12Z",
    fill: "#474747"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_439_297",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 112H244V148C244 154.627 238.627 160 232 160H12C5.37258 160 0 154.627 0 148V112Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 112H244V148C244 154.627 238.627 160 232 160H12C5.37258 160 0 154.627 0 148V112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 112H244H0ZM245 148C245 155.18 239.18 161 232 161H12C4.8203 161 -1 155.18 -1 148H1C1 154.075 5.92487 159 12 159H232C238.075 159 243 154.075 243 148H245ZM12 161C4.8203 161 -1 155.18 -1 148V112H1V148C1 154.075 5.92487 159 12 159V161ZM245 112V148C245 155.18 239.18 161 232 161V159C238.075 159 243 154.075 243 148V112H245Z",
    fill: "#EBEBEB",
    mask: "url(#path-2-inside-1_439_297)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6569 160H12C5.37258 160 0 154.627 0 148V70.4709C0.0186945 70.4738 0.0373928 70.4767 0.056095 70.4797C7.05165 71.5791 14.074 68.6703 18.2432 62.9463C25.7816 52.5967 41.2184 52.5967 48.7568 62.9463C52.926 68.6703 59.9484 71.5791 66.9439 70.4797C79.5926 68.4918 90.5081 79.4073 88.5202 92.056C87.4208 99.0515 90.3296 106.074 96.0536 110.243C106.403 117.782 106.403 133.218 96.0536 140.757C90.3296 144.926 87.4208 151.948 88.5202 158.944C88.5758 159.297 88.6213 159.649 88.6569 160Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.3bb2df697e6461671f0a9590ad3da411.svg";
export { ForwardRef as ReactComponent };